import { useCallback, useContext, useState } from 'react';

import { context as DependencyContext } from '../../context/dependency';

const useResolveModificationRequestIssue = () => {
  const dependency = useContext(DependencyContext);
  const [loading, setLoading] = useState(0);
  const resolveIssue = useCallback(
    async (modificationRequestIssueId: string, success: () => void) => {
      setLoading((loading) => ++loading);
      try {
        await dependency.modificationRequestWebApi.resolveModificationRequestIssue(modificationRequestIssueId);
        dependency.messageDispatcher.notifyUnimportant('message.modification_request_issue.change_state.closed');
        success();
      } catch (err) {
        console.log(err);
        dependency.errorPresenter.showAsNonFatal(new Error('message.modification_request_issue_change_state.failed'));
      } finally {
        setLoading((loading) => --loading);
      }
    },
    [dependency.modificationRequestWebApi, dependency.messageDispatcher, dependency.errorPresenter],
  );
  return { resolveIssue, loading: loading > 0 };
};
export default useResolveModificationRequestIssue;
